import React from 'react';
import { FlexDiv } from '../../../design-system/containers';
import { TextDefault } from '../../../design-system/texts';
import { useTranslation } from 'react-i18next';
import { ThemedButton } from '../../../themed/themed-button/ThemedButton';

export default function StartFeedbackMobile({ startDecisionsSubjectVideo }) {
    const { t } = useTranslation();

    return (
        <FlexDiv
            justifyCenter
            alignCenter
            padding={20}
            fullWidth
            column
            gap={16}
            mobileOnly
        >
            <TextDefault center>
                {t('decisionSubjectStartFeedbackDescription')}
            </TextDefault>
            <ThemedButton mode="secondary" onClick={startDecisionsSubjectVideo}
            text={t('decisionSubjectStartFeedbackButton')}
            >
            </ThemedButton>
        </FlexDiv>
    );
}
